import React from "react";
import { Autocomplete, Skeleton, TextField } from "@mui/material";
import {
  FilterDistributors,
  useDistributorsContext,
} from "../Contexts/distributorsContext";

export default function DistributorSelection({ type, filterByCanOrderBeer, onChange }) {
  const {
    distributors,
    isReady: areDistributorsReady,
    selectedDistributor,
    setSelectedDistributor,
  } = useDistributorsContext();

  if (!areDistributorsReady) {
    return (
        <React.Fragment>
            <Skeleton variant="rectangular" width={500} height={50} />{" "}
        </React.Fragment>
    );
  }

  let filteredDistributors = distributors;

  if (type) {
    filteredDistributors = filteredDistributors.filter(
      (distributor) => distributor.type === type,
    );
  }
  if (filterByCanOrderBeer) {
    filteredDistributors = filteredDistributors.filter(
      (distributor) => distributor.canOrderBeer,
    );
  }

  return (
    <React.Fragment>
      {areDistributorsReady ? (
        <Autocomplete
          disablePortal
          filterOptions={(options, state) =>
            FilterDistributors(options, state.inputValue.toLocaleLowerCase())
          }
          id="combo-box-distributor"
          getOptionLabel={(option) => `${option.sapId} - ${option.name}`}
          options={filteredDistributors}
          sx={{ width: 400 }}
          renderInput={(params) => (
            <TextField {...params} label="Select a Distributor" />
          )}
          value={selectedDistributor || null}
          onChange={(event, value) => {
            setSelectedDistributor(value);
            onChange?.(value);
          }}
        />
      ) : (
        <Skeleton variant="rectangular" width={500} height={50} />
      )}
    </React.Fragment>
  );
}